<template>
  <div class="content_block_container">
   
          <b-row class="content_block_topbar">
              <b-col><h5 class="title_content_block">Bloc de texte</h5></b-col>
              <b-col style="text-align:right;">
                  <b-button class="controller_button_content" @click="$emit('shiftUpBlock',index)"><b-icon icon="caret-up-fill" aria-hidden="true"></b-icon></b-button>
                  <b-button class="controller_button_content" @click="$emit('shiftDownBlock',index)"><b-icon icon="caret-down-fill" aria-hidden="true"></b-icon></b-button>
                  <b-button class="controller_button_content" @click="$emit('deleteBlock',index)"><b-icon icon="trash-fill" aria-hidden="true"></b-icon></b-button>
              </b-col>
          </b-row>

      
    <vue-editor class="wysiwyg_editor"  v-model="htmlcontent" style="background-color: white;"></vue-editor>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  props: ["content", "index"],
  components: { VueEditor },
  data() {
    return {
      htmlcontent: "",
    };
  },
  watch: {
      content: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
          this.htmlcontent = this.content;
          this.$emit("updateContent", {content : this.htmlcontent, index : this.index});
      },
    },
    htmlcontent: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
          this.$emit("updateContent", {content : this.htmlcontent, index : this.index});
      },
    },
  },
  created() {
    this.htmlcontent = this.content;
  },
};
</script>

<style >

.wysiwyg_editor{
    background-color:white;
    margin:20px 10px;
}


</style>